module.exports = __webpack_public_path__ + "static/media/twsGraphics.6927fa27.png";